module.exports = __webpack_public_path__ + "img/mediapack.70e659fd.jpg";